/**
 * Card image: the first click opens the product page. Variant swatches with a
 * featured image replace the photo; swatches without one leave it unchanged.
 * Kalles writes data-srcset at width=1, which never replaces an already-loaded src.
 */
(function () {
  var WIDTHS = [100, 200, 330, 400, 500, 600, 700, 800, 900];

  function cardWidth(img) {
    var box = img.closest('.t4s-product-img') || img;
    var css = Math.ceil((box.clientWidth || 400) * (window.devicePixelRatio || 1));
    var chosen = WIDTHS[WIDTHS.length - 1];
    for (var i = 0; i < WIDTHS.length; i++) {
      if (WIDTHS[i] >= css) {
        chosen = WIDTHS[i];
        break;
      }
    }
    return chosen;
  }

  function sizedUrl(raw, width) {
    if (!raw || raw === 'none') return '';
    var url = String(raw).trim().split(/\s+/)[0];
    if (!url || url === 'none') return '';
    url = url.replace(/^https?:/, '');
    if (url.indexOf('//') === 0) {
      var path = url.replace(/^\/\/[^/]+/, '');
      if (path.indexOf('/cdn/') === 0) url = path;
    }
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + width);
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function withVariant(href, vid) {
    if (!href || !vid) return href;
    if (/variant=/.test(href)) return href.replace(/(variant=)[^&]+/, '$1' + vid);
    if (href.indexOf('?') >= 0) return href + '&variant=' + vid;
    return href + '?variant=' + vid;
  }

  function applySwatch(swatch) {
    if (!swatch || swatch.classList.contains('is--colors-more')) return;
    var raw = swatch.getAttribute('data-img');
    if (!raw || raw === 'none') return;
    var product = swatch.closest('.t4s-product, .t4s-product2');
    if (!product) return;
    var img = product.querySelector('img[data-pr-img]');
    if (!img) return;
    var url = sizedUrl(raw, cardWidth(img));
    if (!url) return;
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.src = url;

    var list = swatch.closest('[data-color-options]');
    if (list) {
      list.querySelectorAll('.is-swatch--selected').forEach(function (el) {
        if (el !== swatch) el.classList.remove('is-swatch--selected');
      });
    }
    swatch.classList.add('is-swatch--selected');
    product.classList.add('t4s-colors-selected');

    var vid = swatch.getAttribute('data-vid');
    if (!vid) return;
    product.querySelectorAll('[data-pr-href]').forEach(function (link) {
      link.setAttribute('href', withVariant(link.getAttribute('href'), vid));
    });
  }

  function schedule(swatch) {
    applySwatch(swatch);
    setTimeout(function () {
      applySwatch(swatch);
    }, 40);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.t4s-pr-color__item');
    if (swatch) schedule(swatch);
  });

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.t4s-pr-color__item');
    if (!swatch || swatch.contains(e.relatedTarget)) return;
    schedule(swatch);
  });
})();

/**
 * Card footer tooltips: same Kalles pipeline as swatches (T4SThemeSP.Tooltip + hoverIntent).
 * - If [data-replace-*] placeholders ever ship data-tooltip="top" again, theme JS produces
 *   data-tooltip="toptop" (invalid placement) and hoverIntent never runs — see snippet comment.
 * - Repair any existing bad values, sync explicit data-t4s-tooltip + aria-label, re-run Tooltip().
 * - T4SThemeSP.isTouch: theme skips floating tooltips entirely (use title / aria-label).
 */
(function () {
  var debounceTimer;

  var VALID_PLACEMENT = /^(top-start|top|top-end|left-start|left|left-end|right-start|right|right-end|bottom-start|bottom|bottom-end)$/;

  function labelFromTextPr(el) {
    var pr = el.querySelector('.t4s-text-pr');
    if (!pr || !pr.textContent) return '';
    return pr.textContent.replace(/\s+/g, ' ').trim();
  }

  function syncCardFooterTooltips() {
    var $ = window.jQuery_T4NT || window.jQuery;
    var footers = document.querySelectorAll('.rokhu-product-btns-wrap--card-footer');
    if (!footers.length) return;

    footers.forEach(function (wrap) {
      wrap.querySelectorAll('[data-tooltip]').forEach(function (el) {
        var v = (el.getAttribute('data-tooltip') || '').trim();
        if (v && !VALID_PLACEMENT.test(v)) {
          var ne = el.cloneNode(true);
          ne.setAttribute('data-tooltip', 'top');
          el.parentNode.replaceChild(ne, el);
        }
      });

      wrap.querySelectorAll('a.t4s-pr-item-btn, button.t4s-pr-item-btn').forEach(function (el) {
        var text = labelFromTextPr(el);
        if (!text) return;
        el.setAttribute('data-t4s-tooltip', text);
        el.setAttribute('aria-label', text);
        var prevTitle = el.getAttribute('title');
        if (!prevTitle || prevTitle === '') el.setAttribute('title', text);
      });

      wrap.querySelectorAll('.t4s-pr-item-btn.t4s-pr-wishlist.is--growave').forEach(function (el) {
        if (el.tagName === 'A' || el.tagName === 'BUTTON') return;
        var PS = window.T4SProductStrings;
        var text = PS && PS.add_to_wishlist ? PS.add_to_wishlist : '';
        if (!text) return;
        el.setAttribute('data-tooltip', 'top');
        if (!el.getAttribute('title')) el.setAttribute('title', text);
        el.setAttribute('data-t4s-tooltip', text);
        el.setAttribute('aria-label', text);
      });
    });

    if (!$ || !window.T4SThemeSP || typeof window.T4SThemeSP.Tooltip !== 'function') return;

    $('.rokhu-product-btns-wrap--card-footer [data-tooltip].t4s-tooltip-actived').each(function () {
      $(this).trigger('updateTooltip');
    });

    if (!window.T4SThemeSP.isTouch) {
      try {
        window.T4SThemeSP.Tooltip();
      } catch (e) {}
    }
  }

  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncCardFooterTooltips, 60);
  }

  function whenTooltipApiReady(done, attempt) {
    attempt = attempt || 0;
    if (window.T4SThemeSP && typeof window.T4SThemeSP.Tooltip === 'function') {
      done();
      return;
    }
    if (attempt > 100) {
      syncCardFooterTooltips();
      return;
    }
    setTimeout(function () {
      whenTooltipApiReady(done, attempt + 1);
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    whenTooltipApiReady(schedule);
  });

  window.addEventListener('load', function () {
    whenTooltipApiReady(schedule);
    setTimeout(function () {
      whenTooltipApiReady(schedule);
    }, 300);
  });

  document.addEventListener('shopify:section:load', schedule);

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('#MainContent') || document.body;
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  });
})();

/**
 * On a narrow product form, the full add-to-cart sentence is clipped.
 * Show the short label only while the button still says that sentence.
 */
(function () {
  function sync(btn) {
    var full = btn.querySelector('.t4s-btn-atc_text');
    if (!full) return;
    var expected = (btn.getAttribute('data-atc-full') || '').replace(/\s+/g, ' ').trim();
    var current = (full.textContent || '').replace(/\s+/g, ' ').trim();
    btn.classList.toggle('rokhu-atc-use-short', expected !== '' && current === expected);
  }

  function scan(root) {
    (root || document).querySelectorAll('.t4s-product-form__submit[data-atc-full]').forEach(sync);
  }

  function watch(btn) {
    if (btn.__rokhuAtcShort) return;
    btn.__rokhuAtcShort = true;
    sync(btn);
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      sync(btn);
    }).observe(btn, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    document.querySelectorAll('.t4s-product-form__submit[data-atc-full]').forEach(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    (e.target || document).querySelectorAll('.t4s-product-form__submit[data-atc-full]').forEach(watch);
  });
})();

/**
 * Cart checkout stays on the page until the terms box is checked.
 * Show that reason beside the checkbox instead of failing silently.
 */
(function () {
  var FALLBACK = 'Bitte stimmen Sie den Nutzungsbedingungen zu, um zur Kasse zu gehen.';

  function message() {
    var strings = window.T4Sstrings;
    if (strings && strings.agree_checkout) return strings.agree_checkout;
    return FALLBACK;
  }

  function rowFor(box) {
    return box.closest('.t4s-cart__agree') || box.parentElement;
  }

  function ensureMsg(row) {
    var next = row.nextElementSibling;
    if (next && next.classList.contains('rokhu-cart-agree-msg')) return next;
    var msg = document.createElement('p');
    msg.className = 'rokhu-cart-agree-msg';
    msg.setAttribute('role', 'alert');
    msg.hidden = true;
    row.insertAdjacentElement('afterend', msg);
    return msg;
  }

  function show(box) {
    var row = rowFor(box);
    var msg = ensureMsg(row);
    row.classList.add('is--agree-error');
    msg.textContent = message();
    msg.hidden = false;
    box.setAttribute('aria-invalid', 'true');
    if (msg.scrollIntoView) msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clear(box) {
    var row = rowFor(box);
    row.classList.remove('is--agree-error');
    var msg = row.nextElementSibling;
    if (msg && msg.classList.contains('rokhu-cart-agree-msg')) msg.hidden = true;
    box.removeAttribute('aria-invalid');
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[name="checkout"], [data-agree-btn], [name="goto_pp"], [name="goto_gc"]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var box = form.querySelector('[type="checkbox"][data-agree-checkbox]');
      if (!box || box.checked) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      show(box);
    },
    true
  );

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[type="checkbox"][data-agree-checkbox]');
    if (box && box.checked) clear(box);
  });
})();

/**
 * Shopify's chat widget opens, closes, and minimizes only on click.
 * On iPhone the first tap stays a hover, so the bubble and the panel
 * controls need a second tap. Perform that click on the first touch.
 */
(function () {
  var roots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function controlFrom(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.tagName) continue;
      if (node.tagName === 'BUTTON' || node.tagName === 'A') return node;
      if (node.getAttribute && node.getAttribute('role') === 'button') return node;
    }
    return null;
  }

  function onTouchEnd(event) {
    var control = controlFrom(event);
    if (!control || control.disabled) return;
    if (event.cancelable) event.preventDefault();
    control.dataset.rokhuTapAt = String(Date.now());
    control.click();
  }

  function onClick(event) {
    if (!event.isTrusted) return;
    var control = controlFrom(event);
    if (!control) return;
    var at = Number(control.dataset.rokhuTapAt || 0);
    if (!at || Date.now() - at > 700) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function patch() {
    var host = document.querySelector('shopify-chat');
    var runtime = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = runtime && runtime.shadowRoot;
    if (!root || (roots && roots.has(root))) return !!root;
    if (roots) roots.add(root);
    root.addEventListener('touchend', onTouchEnd, { capture: true, passive: false });
    root.addEventListener('click', onClick, true);
    return true;
  }

  if (patch()) return;
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (patch() || tries > 40) clearInterval(timer);
  }, 500);
})();
